(ns frontend.actions.kpi-category
  (:require [frontend.conn :as conn]
            [promesa.core :as p]))

(defn *->create-empty! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/create-empty
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->finalize! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/finalize
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->add-report! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/add-report
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->abort! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/abort
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->update-member! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/update-member
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->cleanup! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/cleanup
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->view-ad! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/view-ad
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->disable-member! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/disable-member!
                   data)
      (p/then on-success!)
      (p/catch on-error!)))

(defn *->remove-category! [data on-success! on-error!]
  (-> (conn/sendp! :kpi-category/remove
                   data)
      (p/then on-success!)
      (p/catch on-error!)))
